import { List, P, Strong } from '@ahmdigital/ui';

import { ambulanceDisclaimerTasQld } from './shared';
import limitsRollover from './limits-rollover';

export default {
  intro: {
    accidentOverrideDescription: (
      <>
        <P>Seriously schmick silver with a loyalty extras limit and these added hospital services:</P>
        <List variant={['inside', 'withBottomMargin']}>
          <li>
            <Strong>Joint replacements</Strong>
          </li>
          <li>
            <Strong>Cataracts</Strong>
          </li>
          <li>
            <Strong>Dialysis for chronic kidney failure</Strong>
          </li>
          <li>
            <Strong>Insulin pumps</Strong>
          </li>
          <li>
            <Strong>Pain management with device</Strong>
          </li>
          <li>
            <Strong>Sleep studies</Strong>
          </li>
          <li>
            <Strong>No excess for dependants</Strong>
          </li>
          <li>
            <Strong>Unlimited medically necessary ambulance^</Strong>
          </li>
        </List>
        <P>
          You also benefit from an extras limit that goes up every year for 5 years (and could get you up to $1500 by
          year 5) and <Strong>a separate $300 optical limit</Strong>. It’s comprehensive cover that makes sense.
          ‘Witness the schmickness.’ as we say.
        </P>
      </>
    ),
    description: (
      <>
        <P>Seriously schmick silver with a loyalty extras limit and these added hospital services:</P>
        <List variant={['inside', 'withBottomMargin']}>
          <li>
            <Strong>Joint replacements</Strong>
          </li>
          <li>
            <Strong>Cataracts</Strong>
          </li>
          <li>
            <Strong>Dialysis for chronic kidney failure</Strong>
          </li>
          <li>
            <Strong>Insulin pumps</Strong>
          </li>
          <li>
            <Strong>Pain management with device</Strong>
          </li>
          <li>
            <Strong>Sleep studies</Strong>
          </li>
        </List>
        <P>
          Comes complete with <Strong>unlimited medically necessary ambulance^, accident override</Strong> and{' '}
          <Strong>no excess for dependants</Strong>. You also benefit from an extras limit that goes up every year for 5
          years (and could get you up to $1500 by year 5) and <Strong>a separate $300 optical limit</Strong>. It’s
          comprehensive cover that makes sense. ‘Witness the schmickness.’ as we say.
        </P>
      </>
    ),
    disclaimer: ambulanceDisclaimerTasQld,
  },
  limitsRollover: {
    disclaimer: limitsRollover.disclaimer.flexiLimits,
    rollingOverLimitsText: limitsRollover.rollingOverLimitsText.flexiLimits,
  },
};
